import React from 'react';
import { CheckCircle, Shield, TrendingUp } from 'lucide-react';

const CONTENT = {
  en: {
    why: "Why It",
    works: " Works ",
    benefits: [
      { title: "Specialized Leads", description: "Filtered by job title, industry, company size, square footage, and geography — so your message lands with the right person." },
      { title: "Double-Verified Contacts", description: "We clean and verify every list before you get it. That means better response rates and fewer dead ends." },
      { title: "DIY, Not Alone", description: "You get full control of your lead generation — but we're going to give you materials to support your strategy with smart targeting and campaign ideas." },
    ],
  },
  es: {
    why: "Por qué",
    works: " funciona ",
    benefits: [
      { title: "Leads especializados", description: "Filtrados por cargo, industria, tamaño de empresa, metros cuadrados y geografía; así tu mensaje llega a la persona correcta." },
      { title: "Contactos doblemente verificados", description: "Limpiamos y verificamos cada lista antes de entregártela. Eso significa mejores tasas de respuesta y menos callejones sin salida." },
      { title: "Hazlo tú mismo, pero no solo", description: "Tienes el control total de tu generación de leads, pero te damos materiales para apoyar tu estrategia con segmentación inteligente e ideas de campaña." },
    ],
  },
};

const WhyItWorks = ({ lang = "en" }) => {
  const t = CONTENT[lang] || CONTENT.en;
  const benefits = [
    { icon: CheckCircle, ...t.benefits[0] },
    { icon: Shield, ...t.benefits[1] },
    { icon: TrendingUp, ...t.benefits[2] },
  ];

  return (
    <section className="pb-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <p className="text-3xl font-bold text-[#1465B7]">
            {t.why}
            <span className='text-[#26A94A]'>{t.works}</span>
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12 max-w-5xl mx-auto">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-[#E4F6F9]  rounded-3xl shadow-lg text-center hover:shadow-xl transition-shadow border-3 border-[#1465B7]">
              <div className='bg-[#30A61D] p-3 rounded-2xl'>
              <h3 className="text-2xl font-bold text-white">
                {benefit.title}
              </h3>
              </div>
              <p className="text-gray-600 text-lg py-4 px-3 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyItWorks;
